import "maplibre-gl/dist/maplibre-gl.css";
import { Link } from "wouter";
import { CheckinList } from "../components/CheckinList";
import { HistoryMap } from "../components/HistoryMap";

export function Home() {
  return (
    <>
      <details>
        <summary>Canvas Collector</summary>

        <p>
          Find <a href="https://www.dublincanvas.com/">Dublin Canvas</a>{" "}
          artworks and check them off as you explore the city.
        </p>

        <p>Your data never leaves this device (but still might get lost 😅).</p>

        <p>
          <em>
            Data from{" "}
            <a href="https://data.smartdublin.ie/dataset/dublin-canvas-public-art">
              Dublinked
            </a>{" "}
            and <a href="https://www.dublincanvas.com">dublincanvas.com</a>.
            Mapped using{" "}
            <a href="https://openfreemap.org" target="_blank">
              OpenFreeMap
            </a>{" "}
            <a href="https://www.openmaptiles.org/" target="_blank">
              <small>©</small>OpenMapTiles
            </a>{" "}
            Data from{" "}
            <a href="https://www.openstreetmap.org/copyright" target="_blank">
              OpenStreetMap
            </a>
            .
          </em>
        </p>
      </details>
      <HistoryMap />

      <Link className="checkin-button" to="/nearby">
        Find Nearby Artworks &rarr;
      </Link>
      <CheckinList />
    </>
  );
}
